// extracted by mini-css-extract-plugin
export default {"quantity_wrapper":"YY","increment":"ZY","decrement":"aZ","product":"bZ","product_info":"cZ","text":"eZ","modify_btn":"fZ","controls":"gZ","price":"hZ","deliveredOnce":"iZ"};
    if(module.hot) {
      // 1714442371365
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  